/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { SourcesRequestBuilderRequestsMetadata, type SourcesRequestBuilder } from './sources/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargepoints/consumption
 */
export interface ConsumptionRequestBuilder extends BaseRequestBuilder<ConsumptionRequestBuilder> {
    /**
     * The sources property
     */
    get sources(): SourcesRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const ConsumptionRequestBuilderUriTemplate = "{+baseurl}/chargepoints/consumption";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ConsumptionRequestBuilderNavigationMetadata: Record<Exclude<keyof ConsumptionRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    sources: {
        requestsMetadata: SourcesRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
